import TriggeredHookContextDecorator from "../../../App/Compositions/TriggeredHookContextDecorator";
import useResilientCreateMedicalNonCanLeadResult from "../Hooks/useResilientCreateMedicalNonCanLeadResult";

/** Decorate the {@link useResilientCreateMedicalNonCanLeadResult} hook, providing context-aware parameters. */
const ComposedUseCreateMedicalNonCanLeadResult = TriggeredHookContextDecorator(
  useResilientCreateMedicalNonCanLeadResult,
  ({ leadIdCState, patient, disqualifyingReasonsCState }) => ({
    leadId: leadIdCState,
    patientId: patient.id,
    patientOpportunityId: patient.opportunity.id,
    disqualifyingReasons: disqualifyingReasonsCState || []
  })
);

export default ComposedUseCreateMedicalNonCanLeadResult;
